// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__xeZfq","card_more":"Cards_card_more__XF8Kz"};